import { Box } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import { Frame } from "./Frame"

interface Props {
    fileContent: Blob | undefined
}

const PreviewScreen = ({ fileContent }: Props) => {
    const frameRef = useRef<HTMLIFrameElement>(null)

    const [data, setData] = useState("")

    useEffect(() => {
        const reader = new FileReader()

        if (fileContent) reader.readAsText(fileContent)
        reader.onload = () => {
            setData(reader.result?.toString() ?? "")
        }
    }, [fileContent])

    return (
        <Box
            sx={{
                position: "relative",
            }}
        >
            <Frame data={data} frameRef={frameRef} />
        </Box>
    )
}
export default PreviewScreen
